<template>
  <div id="crumbs">
    <div
      class="btn-group btn-group-sm"
      role="group"
      aria-label="First group"
      @mouseenter="openPresetMenu"
      @mouseleave="closePresetMenu"
    >
      <button
        type="button"
        class="btn btn-aac"
        :class="{ 'btn-all-agent': auth.user.role === 7 }"
        @mouseenter="openSubWSecond('all')"
        @mouseleave="closeSubWSecond('all')"
      >
        {{ stats == 0 ? "ALL" : kFormatter(stats) }}
        <!--                    <div class="bb-sub-menu" v-if="ifCalendarSelected!==false">-->
        <div class="bb-sub-menu" v-if="checkSubMenuMode('all')">
          <!--          <div class="bb-sub-menu-ms" @click.stop="openMsW('lda')">-->
          <!--            <div class="lda-color bb-item">-->
          <!--              <i class="fas fa-bars"></i>-->
          <!--            </div>-->
          <!--            <div class="fake-column lda-color"></div>        </div>-->
          <div
            class="bb-sub-menu-reset"
            @click.stop="closeResetBtnW('all')"
            v-tooltip="{ content: `Reset` }"
          >
            <div class="aac-color bb-item">
              <i class="fas fa-times"></i>
            </div>
            <div class="fake-column aac-color"></div>
          </div>
        </div>
        <div class="bb-sub-menu" v-if="checkIfSecondView('all')">
          <div
            class="bb-sub-menu-ms"
            @click.stop="filterMultipleTags('filter', 'all')"
            v-tooltip="{ content: `Productivity` }"
          >
            <div class="aac-color bb-item">
              <div class="first-circle"></div>
              <div class="second-circle "></div>
              <div class="fake-column aac-color"></div>
            </div>
          </div>
        </div>
        <div class="bb-title-wrapper upper-title">
          <span class="">All</span>
        </div>
        <div
          class="tags-dropdown"
          v-if="
            openTagDropdown &&
              mouseOver &&
              !checkSubMenuMode('all') &&
              !checkIfSecondView('all') &&
              CheckUserPermission([1, 2, 3, 4, 5, 12])
          "
        >
          <TagsDropdown
            :btnColors="btnColors"
            @presetTrigger="emitPresetTrigger"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import { mapGetters, mapState } from "vuex";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import { Globals } from "@/global_constants/constants";
import TagsDropdown from "./TagsDropdown.component";

export default {
  name: "AllActiveBreadButton",
  mixins: [UsersPermissionCheck, breadButtonsFunctionsUtil, calendarCheck],
  props: {
    ifCalendarSelected: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabledLeading: {
      type: Boolean,
      required: false,
      default: () => false
    },
    stats: {
      type: Number,
      required: false
    },
    statsLeadingActive: {
      type: Number,
      required: false
    },
    totalDisable: {
      type: Boolean,
      required: false,
      default: () => false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    queryObject: {
      type: Object
    }
  },
  components: {
    TagsDropdown
  },
  data() {
    return {
      showPopup: false,
      intervals: [],
      slideBtn: {
        ld: false
      },
      resetBtn: {
        ld: false
      },
      openTagDropdown: false,
      mouseOver: false,
      btnColors: {
        backgroundColor: "#f5f7ff",
        color: "black"
      },
      calendarForPreset: "REG"
    };
  },

  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["shortCutsToBlocks"]),

    btnStyles() {
      return {
        "--bg-color":
          this.disabled || this.totalDisable ? "#546e7a" : this.bgColor,
        "--hover-on-disable":
          this.disabled || this.totalDisable ? "-3px" : "0px",
        "--cursor-on-total-disable": !this.totalDisable ? "pointer" : "default",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },
    btnLeadingStyles() {
      return {
        "--selling-group-bg-color": this.disabledLeading
          ? "#546e7a"
          : "#009147",
        "--hover-on-disable": this.disabledLeading ? "-3px" : "0px",
        "--font-weight": this.disabledLeading ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },

  methods: {
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    },
    kFormatterEar: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      return "";
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("regular", "all");
      }
    },
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    }
  },
  watch: {
    leftEar: function() {
      if (this.leftEar > 0) {
        this.intervals.push(
          setInterval(() => {
            const yellow = "#fbc02d";
            const red = "#c62828";
            const grey = "#546e7a";
            this.yellow = grey;
            // let that = this;
            setTimeout(() => {
              this.yellow = yellow;
            }, 1500);
          }, 3000)
        );
      }
      if (this.leftEar < 1) {
        for (let i = 0; i < this.intervals.length; i++) {
          clearInterval(this.intervals[i]);
        }
        this.intervals = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$color: var(--bg-color);
$ldaColor: #546e7a;
$aacColor: #008b00;
$otherNewColor: var(--other-new-bg-color);
$sellingGroupColor: var(--selling-group-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: $color;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 12px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-weight: 500;
  /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.dot-right {
  height: 20px;
  width: 20px;
  border: 1px solid #009147;
  border-radius: 5px;

  color: #009147;
  /*border-radius: 50%;*/
  bottom: 20px;
  right: 0;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-right:hover {
  /*background-color: #90a4ae;*/
}

.dot-left {
  height: 26px;
  width: 26px;
  background-color: $otherNewColor;
  border-radius: 50%;
  bottom: 8px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left:hover {
  /*background-color: #90a4ae;*/
}

.dot-bottom-left {
  height: 26px;
  width: 26px;
  color: white;
  background-color: $sellingGroupColor;
  border-radius: 50%;
  top: 12px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-bottom-left:hover {
  background-color: #90a4ae;
}

.btn-aac {
  font-size: 10px;
  //color: #ffffff;
  transition: all 0.2s ease-in;
  padding-top: 5px;
  width: 100%;
  /*margin-right: 10px;*/
  border-radius: 5px !important;
  transition: all 0.3s;
  background-color: #f5f7ff;
  //border-color: #008b00;
  outline: none;
  position: relative;
  cursor: default;
  /*min-height: 27px;*/
  /*min-width: 20px;*/
}

.btn-aac:hover,
.btn-aac:focus,
.btn-aac:active,
.btn-aac.active .open .dropdown-toggle.btn-all {
  //color: #ffffff;
  background-color: #f5f7ff;
  //border-color: #008b00;
  outline: none;
  z-index: 0 !important;
}

.btn-aac:hover {
  //color: #ffffff;
  //background-color: $btnColor;
  //border-color: $btnColor;
  outline: none;
  z-index: 1 !important;
  cursor: default;
}

.slide-btn {
  position: absolute;
  top: 26px;
  background-color: inherit;
  width: 100%;
  left: 0px;
  border-radius: 0px 0px 30px 30px;
}

.reset-btn {
  position: absolute;
  top: -5px;
  right: 0px;
  color: grey;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  transform: scale(1.3);
  color: red;
}

.star-yellow {
  color: yellow;
  font-size: 12px;

  /*<!--margin-left: -13px;-->*/
}

.btn-all:first-child {
  /*width: 66px;*/
}

#crumbs .btn-group-sm {
  display: flex;
}

.btn-aac:hover {
  transform: scale(1.1);
}

span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 0px;
  font-size: 8px;
}

div.bb-title-wrapper {
  //position: absolute;
  color: black;
  font-size: 8px;
  width: 100%;
  top: 25px;
  left: 0px;
  text-align: center;
}

.btn-all-agent {
  width: 80px;
}

.upper-title {
  text-transform: uppercase;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
  cursor: pointer;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.lda-color {
  background-color: $ldaColor;

  //$otherNewColor
  //$sellingGroupColor
}

.aac-color {
  background-color: $aacColor;
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.fake-btn-all {
  background: none;
  color: #546e7a;
  border: none;
  font-size: 10px;
  transition: all 0.2s ease-in;
  padding-top: 5px;
  width: 50%;
  margin-right: 10px;
  border-radius: 5px !important;
  transition: all 0.3s;
  outline: none;
  position: relative;
}

.fake-btn-all:hover,
.fake-btn-all:focus,
.fake-btn-all:active,
.fake-btn-all.active .open .dropdown-toggle.fake-btn-all {
  color: #546e7a;
  background: none;
  border: none;
  outline: none;
  cursor: default;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}
</style>
